import TemplateView from '../../../../TemplateView'
import WorkdayDurationsEditor from '../../../../controls/WorkdayDurationsEditor'

export default class TableHeader extends TemplateView {
    constructor() {
        super()

        this.state = {
            weekStartDay: 0
        }

        this.onStatePropertyChanged('weekStartDay', weekStartDay => this._update(weekStartDay))
    }

    templateHtml() {
        return '<table class="workScheduleTableHeader"/>'
    }

    _update(weekStartDay) {
        this.getEl().empty().append(WorkdayDurationsEditor.buildTableHeader(weekStartDay))
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/user/accountSettings/workSchedule/TableHeader.js